<div
  class="recent-alerts"
  [ngClass]="{ 'recent-alerts--collapsed': !isCollapse }">
  <div class="recent-alerts__header">
    <div class="recent-alerts__title" [ngClass]="{ hidden: !isCollapse }">
      <span>Recent Alerts</span>
      <span class="recent-alerts__title-icon">
        <app-custom-expand-dialog></app-custom-expand-dialog>
      </span>
    </div>
    <button
      type="button"
      class="recent-alerts__collapse"
      [ngClass]="[isCollapse ? 'is-open' : 'is-closed']"
      [attr.aria-label]="
        isCollapse ? 'Collapse Recent Alerts' : 'Expand Recent Alerts'
      "
      (click)="emitChangeSize()">
      <svg-icon class="custom-svg-icon" key="arrow" size="md"></svg-icon>
    </button>
  </div>

  @if (isCollapse) {
    <div class="recent-alerts__tabs">
      @for (tab of tabs; track tab.key) {
        <button
          type="button"
          class="recent-alerts__tab"
          [ngClass]="{ 'is-active': activeTab === tab.key }"
          (click)="setTab(tab.key)">
          {{ tab.label }}
        </button>
      }
    </div>

    <div class="recent-alerts__search">
      <span class="recent-alerts__search-icon">
        <i class="pi pi-search"></i>
      </span>
      <input
        type="text"
        class="recent-alerts__search-input"
        placeholder="Search by rig names, project names, or company names"
        maxlength="120"
        [value]="searchKeyword"
        (keyup)="onKeywordChange($event)"
        aria-label="Search alerts by rig, project, or company" />
    </div>

    <div class="recent-alerts__list-wrap">
      <div class="recent-alerts__list-total">
        <div class="recent-alerts__counter">
          Total: {{ displayLogTotal }} | New: {{ newCount }}
        </div>
        @if (chipFilter) {
          <div class="recent-alerts__chip flex align-items-baseline">
            <span class="me-2">Filtering by:</span>
            <p-chip
              [label]="chipFilter"
              styleClass="p-custom-chip-item"></p-chip>
          </div>
        }
      </div>
      <div
        class="recent-alerts__list"
        #infiniteScroll
        (scroll)="scrollHandler($event)">
        @for (
          interventionLog of displayLogs;
          track interventionLog?.interventionId || $index
        ) {
          <app-nofitication-item-v2
            [interventionLog]="interventionLog"
            [selectedInterventionId]="(interventionLogsActive$ | async)!"
            (alertOpened)="onAlertOpened($event)">
          </app-nofitication-item-v2>
        }

        @if (displayLogs.length === 0) {
          <div class="recent-alerts__empty">
            <svg-icon
              class="custom-svg-icon"
              key="noFilterData"
              size="xxxl"></svg-icon>
            <p>No result found. Try to adjust filters setting</p>
          </div>
        }
      </div>
    </div>

    @if ((isLoadingLoadMore$ | async)!) {
      <div class="recent-alerts__loading">
        <span class="loader"></span>
      </div>
    }
  }
</div>
